var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
// @ts-ignore
import { getElementType } from 'semantic-ui-react/dist/commonjs/lib';
import Text from '../Text';
export const MessageAction = (props) => {
    const { className, handler, label } = props, rest = __rest(props, ["className", "handler", "label"]);
    const ElementType = getElementType(MessageAction, props);
    return (React.createElement(Text, Object.assign({ className: cn(className, 'action'), as: ElementType, onClick: handler }, rest), label));
};
MessageAction.displayName = 'MessageAction';
export default MessageAction;
//# sourceMappingURL=MessageAction.js.map